import React, { useEffect, useState } from "react";
import AP2HS from "./AP2HS";
import ConfigurationStore from "../../stores/ConfigurationStore";
import { observer } from "mobx-react";
import GlobalStore from "../../stores/GlobalStore";
import { Link } from "react-router-dom";
function Configurations() {
  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    ConfigurationStore.getConfigurations();
    GlobalStore.pageName = "configurations";
  }, []);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  let { configurations = [] } = ConfigurationStore;
  return (
    <div className="element-info">
      <div className="tab-list">
        <ul>
          <li
            className={activeTab === "1" ? "active" : ""}
            onClick={() => {
              toggleTab("1");
            }}
          >
            Cognosos → Hubspot
          </li>
        </ul>
      </div>
      <div className="tab-content">
        {activeTab === "1" && (
          <AP2HS
            list={configurations.filter((cf) => cf.configType === "ap2hs")}
          />
        )}
      </div>

      <div className="bottom-button">
        <Link to="/configuration/add">
          <button className="primarybtn add-btn">+ Add Configurations</button>
        </Link>
      </div>
    </div>
  );
}

export default observer(Configurations);
